import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class OptionalCoverageEnrolment extends DomainObject {
  groupBenefitCoverageId;
  coverageTypeTitle;
  carrierName;
  enrolled;
  cost;

  constructor(other) {
    super();

    makeObservable(this, {
      groupBenefitCoverageId: observable,
      coverageTypeTitle: observable,
      carrierName: observable,
      enrolled: observable,
      cost: observable
    });

    this.merge(other);
  }
}

export default OptionalCoverageEnrolment;
